module.exports = __webpack_public_path__ + "img/1_022.f8ecfb4e.jpg";